import gql from 'graphql-tag';

// export const getAllClients = gql`
// query getAllClients{
//     clients(){
//     id
//     created_at
//     name
//     email
//     phone
//     type
//     status

   


//   }
// }
// `;


export const getAllClientsProf = gql`
subscription getAllClientsProf{
    clients(where: {type: {_eq: "PROFESSIONAL"}}){
    abn_number
        blocked_at
        blocked_reason
        businessName
        business_name
        client_verification_key
        client_verified
        country
        created_at
        credits
        dashboard_status
        directory_business_type_id
        directory_category_other_name
        email
        employee_details
        first_name
        id
        internal_note
        last_name
        manager_user_id
        name
        password
        payload
        payment_status
        phone
        postal_code
        professionType
        profile_status
        state
        status
        subscription_expires_at
        subscription_plan_id
        timezone
        tracking_details
        type
        updated_at

   


  }
}
`;


export const getAllClientsSupplier = gql`
subscription getAllClientsSupplier{
    clients(where: {type: {_eq: "SUPPLIER"}}){
    abn_number
        blocked_at
        blocked_reason
        businessName
        business_name
        client_verification_key
        client_verified
        country
        created_at
        credits
        dashboard_status
        directory_business_type_id
        directory_category_other_name
        email
        employee_details
        first_name
        id
        internal_note
        last_name
        manager_user_id
        name
        password
        payload
        payment_status
        phone
        postal_code
        professionType
        profile_status
        state
        status
        subscription_expires_at
        subscription_plan_id
        timezone
        tracking_details
        type
        updated_at

   


  }
}
`;

export const getAllClientsPractice = gql`
subscription getAllClientsPractice{
    clients(where: {type: {_eq: "PRACTICE"}}){
    abn_number
        blocked_at
        blocked_reason
        businessName
        business_name
        client_verification_key
        client_verified
        country
        created_at
        credits
        dashboard_status
        directory_business_type_id
        directory_category_other_name
        email
        employee_details
        first_name
        id
        internal_note
        last_name
        manager_user_id
        name
        password
        payload
        payment_status
        phone
        postal_code
        professionType
        profile_status
        state
        status
        subscription_expires_at
        subscription_plan_id
        timezone
        tracking_details
        type
        updated_at

   


  }
}
`;


export const getClientById = gql`
query getClientById($id: uuid!){
    clients_by_pk(id:$id){
abn_number
        blocked_at
        blocked_reason
        businessName
        business_name
        client_verification_key
        client_verified
        country
        created_at
        credits
        community_status
        community_id
        dashboard_status
        directory_business_type_id
        directory_category_other_name
        email
        employee_details
        first_name
        id
        internal_note
        last_name
        manager_user_id
        name
        password
        payload
        payment_status
        phone
        postal_code
        professionType
        profile_status
        state
        status
        subscription_expires_at
        subscription_plan_id
        timezone
        tracking_details
        type
        updated_at
        updated_at
  }
}
`;

export const getDentalProfById = gql`
query getDentalProfById($id: uuid!){
  dental_professionals_by_pk(id:$id){
    id
    type
    name
    phone
    email
    profile_image
    address
    gender
    date_of_birth
    alt_email
    alt_phone
    profession_type
    bank_details
    pro_details_aphra_registration_number
    driving_licence
    second_hand
    first_name
    middle_name
    last_name
    salutation
  }
}
`;

export const getDentalSupplierById = gql`
query getDentalSupplierById($id: uuid!){
  dental_suppliers_by_pk(id:$id){
   abn_number
        address
        alt_email
        alt_phone
        bank_details
        blocked_at
        blocked_reason
        community_status
        business_email
        business_name
        business_phone
        contact_person_first_name
        contact_person_gender
        contact_person_last_name
        contact_person_middle_name
        contact_person_profile_image
        created_at
        credits
        defaultAddress
        directory_business_type_id
        directory_category_id
        directory_category_other_name
        email
        email_verification_expiry_at
        email_verification_key
        email_verification_required
        email_verified
        fax_number
        first_name
        id
        isEditable
        is_featured
        last_name
        logo
        middle_name
        name
        other_details
        payment_completed
        phone
        phone_verification_expiry_at
        phone_verification_key
        phone_verification_required
        phone_verified
        present_subscription_id
        pro_details_abn_acn_number
        pro_details_aphra_registration_number
        pro_details_driving_license_image
        pro_details_other_attachments
        profession_type
        profile_completed
        profile_image
        second_hand
        secondary_contact
        sell_products
        status
        subsciption_plan_id
        subscription_plan_details
        tga_number
        type
        updated_at
  }
}
`;

export const getDirectoryById = gql`
  query getDirectoryById($id: uuid!) {
    directories(where: { dental_supplier_id: { _eq: $id } }) {
      id
      type
      updated_at
      created_at
      dental_supplier_id
      dental_practice_id
      dental_professional_id
      community_status
      community_id
    }
  }
`;


export const getDentalPracticeById = gql`
query getDentalPracticeById($id: uuid!){
  dental_practices_by_pk(id:$id){
    id
    type
    name
    phone
    email
    logo
    address
    business_name
    abn_number
    business_phone
    fax_number
    alt_email
    alt_phone
    profession_type
    bank_details
    business_email
    secondary_contact
    first_name
    middle_name
    last_name
    second_hand
    sell_products
    alt_email
    alt_phone
    pro_details_aphra_registration_number
    driving_licence
  }
}
`;

export const getUserSubPlans = gql`
query getUserSubscrptions($id:uuid!){
  user_subscriptions(where:{
    _or:[{
      dental_supplier_id: {_eq: $id}
    },{
      dental_practice_id: {_eq: $id}
    },{
      dental_professional_id: {_eq: $id}
    }]
  }){
    id
    created_at
    expires_at
    subscription_plan_id
    dental_supplier_id
    dental_professional_id
    dental_practice_id
    total_amount
    plan_type
    subscription_plan{
      name
      plan_type
      type
    }
    
  }
}
`;


export const updateClientStatusData = gql`

mutation updateClientStatus($id: uuid!, $updateObj: clients_set_input!) {
  update_clients_by_pk(pk_columns: {id: $id},_set: $updateObj) {
    id
   
  }
}
`;



export const getpracticeCount = gql`

subscription getpracticeCount {
  clients_aggregate(where: {type: {_eq: "PRACTICE"}}){

    aggregate{
      count
    }
   
  }
}

`;

export const getSupplierCount = gql`

subscription getSupplierCount {
  clients_aggregate(where: {type: {_eq: "SUPPLIER"}}){

    aggregate{
      count
    }
   
  }
}

`;

export const getProfessionalCount = gql`

subscription getProfessionalCount {
  clients_aggregate(where: {type: {_eq: "PROFESSIONAL"}}){

    aggregate{
      count
    }
   
  }
}

`;




// Add these queries to your existing queries
export const getAllClients = gql`
  query getAllClients {
    clients {
abn_number
        blocked_at
        blocked_reason
        businessName
        business_name
        client_verification_key
        client_verified
        country
        created_at
        credits
        dashboard_status
        directory_business_type_id
        directory_category_other_name
        email
        employee_details
        first_name
        id
        internal_note
        last_name
        manager_user_id
        name
        password
        payload
        payment_status
        phone
        postal_code
        professionType
        profile_status
        state
        status
        subscription_expires_at
        subscription_plan_id
        timezone
        tracking_details
        type
        updated_at
    }
  }
`;

export const getAllClientsCount = gql`
  query getAllClientsCount {
    clients_aggregate {
      aggregate {
        count
      }
    }
  }
`;


export const UPDATE_CLIENT_BY_ID = gql`
  mutation UpdateClientById(
    $id: uuid!
    $updates: clients_set_input!
  ) {
    update_clients_by_pk(
      pk_columns: { id: $id }
      _set: $updates
    ) {
      id
      name
      email
      phone
      postal_code
      
      state
      professionType
      type
      businessName
      subscription_plan_id
      # Include any other fields you need returned
    }
  }
`;



// update clients
export const UPDATE_DENTAL_PROFESSIONAL = gql`
  mutation UpdateDentalProfessional($id: uuid!, $changes: dental_professionals_set_input!) {
    update_dental_professionals_by_pk(pk_columns: {id: $id}, _set: $changes) {
      id
      name
      email
      phone
      # include other fields you want returned
    }
  }
`;

export const UPDATE_DENTAL_SUPPLIER = gql`
  mutation UpdateDentalSupplier($id: uuid!, $changes: dental_suppliers_set_input!) {
    update_dental_suppliers_by_pk(pk_columns: {id: $id}, _set: $changes) {
      id
      business_name
      abn_number
      # include other fields you want returned
    }
  }
`;

export const UPDATE_DENTAL_PRACTICE = gql`
  mutation UpdateDentalPractice($id: uuid!, $changes: dental_practices_set_input!) {
    update_dental_practices_by_pk(pk_columns: {id: $id}, _set: $changes) {
      id
      name
      type
      # include other fields you want returned
    }
  }
`;

export const updateDentalProfessionalStatus = gql`
mutation updateDentalProfessional($id: uuid!, $updateObj: dental_professionals_set_input!) {
  update_dental_professionals_by_pk(pk_columns: {id: $id}, _set: $updateObj) {
    id
  }
}
`;

export const updateDentalSuppliersStatus = gql`
mutation updateDentalSuppliers($id: uuid!, $updateObj: dental_suppliers_set_input!) {
  update_dental_suppliers_by_pk(pk_columns: {id: $id}, _set: $updateObj) {
    id
  }
}
`;

export const updateDentalPracticeStatus = gql`
mutation updateDentalPractice($id: uuid!, $updateObj: dental_practices_set_input!) {
  update_dental_practices_by_pk(pk_columns: {id: $id}, _set: $updateObj) {
    id
  }
}
`;

export const UPDATE_COMMUNITY_STATUS = gql`
  mutation UpdateCommunityStatus(
    $id: uuid!,
    $community_status: String!,
    $community_id: uuid
  ) {
    update_clients_by_pk(
      pk_columns: { id: $id }
      _set: { community_status: $community_status, community_id: $community_id }
    ) {
      id
      community_status
      community_id
    }
  }
`;

export const UPDATE_DENTAL_SUPPLIER_COMMUNITY_STATUS = gql`
  mutation UpdateDentalSupplierCommunityStatus(
    $id: uuid!,
    $community_status: String!,
    $community_id: uuid
  ) {
    update_dental_suppliers_by_pk(
      pk_columns: { id: $id }
      _set: { community_status: $community_status, community_id: $community_id }
    ) {
      id
      community_status
      community_id
    }
  }
`;
export const UPDATE_DENTAL_PRACTICE_COMMUNITY_STATUS = gql`
  mutation UpdateDentalPracticeCommunityStatus(
    $id: uuid!,
    $community_status: String!,
    $community_id: uuid
  ) {
    update_dental_practice_by_pk(
      pk_columns: { id: $id }
      _set: { community_status: $community_status, community_id: $community_id }
    ) {
      id
      community_status
      community_id
    }
  }
`;
export const UPDATE_DENTAL_PROFESSIONAL_COMMUNITY_STATUS = gql`
  mutation UpdateDentalProfessionalCommunityStatus(
    $id: uuid!,
    $community_status: String!,
    $community_id: uuid
  ) {
    update_dental_professional_by_pk(
      pk_columns: { id: $id }
      _set: { community_status: $community_status, community_id: $community_id }
    ) {
      id
      community_status
      community_id
    }
  }
`;
export const UPDATE_DIRECTORY_COMMUNITY_STATUS = gql`
  mutation UpdateDirectoryCommunityStatus(
    $id: uuid!,
    $community_status: String!,
    $community_id: uuid
  ) {
    update_directories(
      where: {
        _or: [
          { dental_supplier_id: { _eq: $id } },
          { dental_professional_id: { _eq: $id } },
          { dental_practice_id: { _eq: $id } }
        ]
      },
      _set: {
        community_status: $community_status,
        community_id: $community_id
      }
    ) {
      returning {
        id
        community_status
        community_id
      }
    }
  }
`;
export const UPDATE_USER_DATA = (table: string, inputType: string) => gql`
mutation UpdateUserData(
  $id: uuid!,
  $clientChanges: clients_set_input!,
  $userChanges: ${inputType}!
) {
  update_clients_by_pk(pk_columns: { id: $id }, _set: $clientChanges) { id }
  update_${table}_by_pk(pk_columns: { id: $id }, _set: $userChanges) { id }
}`;


